import React from 'react';
import { useSelector } from 'react-redux';
import { hasAnyPermission } from '../utils/permissions';

const PagePermissionWrapper = ({ children, requiredPermissions, pageName }) => {
  const { user } = useSelector((state) => state.auth);

  // İzin kontrolü
  if (requiredPermissions && user) {
    const hasAccess = hasAnyPermission(user, requiredPermissions);
    
    if (!hasAccess) {
      return (
        <div className="min-h-[60vh] flex items-center justify-center">
          <div className="text-center max-w-md mx-auto">
            <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-red-100 mb-4">
              <svg className="h-8 w-8 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.694-.833-2.464 0L3.34 16.5c-.77.833.192 2.5 1.732 2.5z" />
              </svg>
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-2">Yetkisiz Erişim</h3>
            <p className="text-gray-600 mb-1">
              <strong>{pageName}</strong> sayfasına erişim yetkiniz bulunmamaktadır.
            </p>
            <p className="text-sm text-gray-500 mb-4">
              Gerekli izinlere sahip değilsiniz. Yöneticinizle iletişime geçin.
            </p>
            <div className="bg-gray-50 rounded-lg p-4">
              <p className="text-xs text-gray-600 mb-2">Gerekli izinler:</p>
              <div className="flex flex-wrap gap-1 justify-center">
                {requiredPermissions.map((permission, index) => (
                  <span 
                    key={index}
                    className="inline-block bg-gray-200 text-gray-700 text-xs px-2 py-1 rounded"
                  >
                    {permission}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      );
    }
  }

  return children;
};

export default PagePermissionWrapper;
